import React from 'react';
import { Heading } from '../components/common/atoms'
import QRCode from '../components/common/templates/Login/QRCode'
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../services';
import { message } from 'antd';
import { successOrFailureToaster } from '../components/common/atoms/messages';

const SettingsQRCodePage = () => {
  const location = useLocation()
  const history = useHistory()

  const qr = location.state?.qr_code 
  const alt_code = location.state?.alternative_code
  const requestAuth = async (code) => {
    let options = { data: { otp_code: code }}

      await appApi.mfaCreate(options,
        (res)=> {
            let msg = res?.data?.message
            successOrFailureToaster({message: msg})
            history.push({pathname: 'mfa-backup-code', state: res.data})
        },
        (e)=>{
            let msg = e?.response?.data?.message
            successOrFailureToaster({message: msg, type: 'fail'})
        });
  }

  return (
    <div>
      <div>
        <Heading mainHeading='Account Settings' subClasses='mt-1 text-sm text-gray-600' />
      </div>
      <div className='rounded-md shadow-md my-4 bg-white px-4 py-4' style={{ width: '26rem' }}>
        <QRCode requestAuth={requestAuth} qr_code={qr} alt_code={alt_code} />
      </div>
    </div>
  )
}

export default SettingsQRCodePage